var swiper = new Swiper(".customers-multicolumn-slider", {
  slidesPerView: 1,
  loop: true,
  spaceBetween: 30,
  autoplay: {
    delay: 3500,
    disableOnInteraction: false,
  },
  breakpoints: {
    750: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
    990: {
      slidesPerView: 4,
      spaceBetween: 30,
    }
  }
});